import { createI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'

// 准备语言包
const messages = {
    en,
    zh
}

// 创建 i18n 实例
const i18n = createI18n({
    legacy: false, // 使用 Composition API 模式
    locale: localStorage.getItem('lang') || 'zh', // 从 localStorage 读取或默认中文
    fallbackLocale: 'zh', // 备用语言
    messages
})

export default i18n